import { render, staticRenderFns } from "./RegisterSecondStep.vue?vue&type=template&id=281e9226&scoped=true&"
import script from "./RegisterSecondStep.vue?vue&type=script&lang=js&"
export * from "./RegisterSecondStep.vue?vue&type=script&lang=js&"
import style0 from "./RegisterSecondStep.vue?vue&type=style&index=0&id=281e9226&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281e9226",
  null
  
)

export default component.exports